import { PAGE_TYPE_LABELS } from '../components/dialog/VersionConfigDialog/constants'

// パスではなく「集計範囲名」と「ページ種別」を並べた表記なので全角にする
const TITLE_SEPARATOR = ' ／ '
// version_report_version_pages.page_title が VARCHAR(256) のため
const PAGE_TITLE_MAX_LENGTH = 256

export const buildTeamPageTitle = (rootName: string): string => {
  const label = PAGE_TYPE_LABELS.PROGRESS_REPORT_BY_TEAM
  const maxRootNameLength =
    PAGE_TITLE_MAX_LENGTH - TITLE_SEPARATOR.length - label.length
  return `${rootName.slice(0, maxRootNameLength)}${TITLE_SEPARATOR}${label}`
}
